import { CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useGcpAuthorize } from "@/hooks/queries/use-cloud";
import { gcpWizardPath, useGcpWizard } from "./wizard-state";

/** Step 2: sign in with Google. Google sends the admin back to the callback page, which lands on step 3. */
export function SignInStep() {
  const { state } = useGcpWizard();
  const authorize = useGcpAuthorize();
  const signedIn = state.session !== null;

  const go = () =>
    authorize.mutate(
      {},
      {
        onSuccess: (url) => {
          window.location.assign(url);
        },
      }
    );

  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold">Sign in with Google</h2>
      <p className="text-sm text-muted-foreground">
        CompBox asks Google for permission to set up the project once. It keeps the sign-in for about an hour, only to run the setup, and
        then throws it away. It stores no Google key; deploys use keyless trust with your GitHub.
      </p>
      {signedIn && (
        <p className="flex items-center gap-1.5 text-sm text-emerald-600">
          <CheckCircle2 className="h-4 w-4" /> You're signed in with Google.
        </p>
      )}
      {authorize.isError && (
        <p role="alert" className="text-sm text-destructive">
          {authorize.error instanceof Error ? authorize.error.message : "Couldn't reach Google."}
        </p>
      )}
      <div className="flex gap-2">
        {signedIn ? (
          <Button asChild>
            <Link to={gcpWizardPath("project")}>Continue</Link>
          </Button>
        ) : null}
        <Button variant={signedIn ? "outline" : "default"} onClick={go} disabled={authorize.isPending}>
          {authorize.isPending ? "Opening Google…" : signedIn ? "Sign in again" : "Sign in with Google"}
        </Button>
        <Button asChild variant="ghost">
          <Link to={gcpWizardPath("start")}>Back</Link>
        </Button>
      </div>
    </div>
  );
}
